module.exports = __webpack_public_path__ + "img/893d5939f65ce39e837dddb5d5143759.png";